import { render, staticRenderFns } from "./ChannelTaxonomySettings.vue?vue&type=template&id=6eb4fa31&"
import script from "./ChannelTaxonomySettings.vue?vue&type=script&lang=js&"
export * from "./ChannelTaxonomySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports